module.exports = __webpack_public_path__ + "static/media/tags.9e159005.svg";